<script setup lang="ts">
import { formatTimeAgoStrict } from '@/filters';
import { computed } from 'vue';

const props = defineProps<{
  insight: {
    id: number;
    title: string;
    created_at: string;
    completed_at: string;
  };
}>();

const timeAgo = computed(() => {
  const time = props.insight.completed_at || props.insight.created_at
  return time ? `${formatTimeAgoStrict(time)}` : 'no info';
});
</script>

<template>
  <div>
    <div class="flex items-start justify-between gap-x-4">
      <div class="flex text-[15px] font-semibold text-gpx_black-500">
        <span>{{ insight.title }}</span>
      </div>
    </div>
    <div class="flex justify-between gap-x-4">
      <div class="ml-auto shrink-0 text-[13px] text-gpx_gray-100">
        Created {{ timeAgo }}
      </div>
    </div>
  </div>
</template>
